import { z } from 'zod'
import { onboardingStatusSchema } from './onboarding-contracts'
import { profileDraftSchema } from './onboarding-profile-contracts'

const day = z.discriminatedUnion('status', [
  z.object({ status: z.literal('CLOSED') }).strict(),
  z
    .object({ status: z.literal('OPEN'), start: z.string(), end: z.string() })
    .strict(),
])
export const clinicHoursSchema = z
  .object({
    schemaVersion: z.literal(1),
    tenantUid: z.string(),
    revision: z.number().int().positive(),
    capabilityFingerprint: z.string(),
    timeZone: z.string(),
    workingHours: z
      .object({
        sun: day,
        mon: day,
        tue: day,
        wed: day,
        thu: day,
        fri: day,
        sat: day,
      })
      .strict(),
    breaks: z.array(
      z.object({
        name: z.string().optional(),
        days: z.array(z.string()),
        start: z.string(),
        end: z.string(),
      })
    ),
    specialDays: z.array(
      z.object({
        name: z.string().optional(),
        date: z.string(),
        status: z.enum(['OPEN', 'CLOSED']),
        start: z.string().optional(),
        end: z.string().optional(),
      })
    ),
    updatedBy: z.string(),
    updatedAtMs: z.number(),
    fingerprint: z.string(),
  })
  .strict()
export const pmsCapabilitySchema = z
  .object({
    schemaVersion: z.literal(1),
    tenantUid: z.string(),
    status: onboardingStatusSchema,
    revision: z.number().int().positive(),
    pmsStatus: z.enum([
      'PMS_INTENTIONALLY_DISABLED',
      'PMS_CONNECTED',
      'PMS_CONNECTION_IN_PROGRESS',
      'PMS_REQUIRED_BUT_INCOMPLETE',
    ]),
    pmsConnectionStatus: z.enum(['NOT_STARTED', 'RESERVED', 'ACTIVE']),
    clinicHours: clinicHoursSchema.nullable(),
    profile: profileDraftSchema.nullable(),
    bookingEnabled: z.literal(false).nullable(),
  })
  .strict()
export type PmsCapabilityResponse = z.infer<typeof pmsCapabilitySchema>
